<template>
    <div :class="{dashboard: this.$route.name !== 'secondLevelDetailsConfig',
                admin_page: this.$route.name == 'secondLevelDetailsConfig'}" class="wrapper">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="pl-3 mb-3">
            <div v-if="(place_guid && organization_guid) == null" class="placeId_input__wrapper">
                <div v-if="this.$route.name == 'secondLevelDetailsConfig' || admin">
                    <md-field class="screen__input">
                        <label>{{ translate('sldPlaceGuid') }}</label>
                        <md-input v-model="place_guid" maxlength="100"/>
                    </md-field>
                    <md-field>
                        <label>{{ translate('sldOrganizationGuid') }}</label>
                        <md-input v-model="organization_guid" maxlength="100"/>
                    </md-field>
                </div>
                <div class="get_place_config" @click="getSecLevelConfigClick">
                  {{ translate('sldGetPlaceConfig') }}
                </div>
            </div>
            <b-form-checkbox v-if="question_guid" v-model="takeSecLevelFromPlace">
                <span>{{ translate('sldTakeFromPlace') }}</span>
            </b-form-checkbox>
            <b-form-checkbox v-model="showSecLevelConfig">
                <span>{{ translate('sldEnableDetails') }} </span>
            </b-form-checkbox>
            <div class="default_configs_wrapper">
                <div class="def_conf_btn" @click="onDefConfigItemClick(item.config)"
                     v-for="item in defaultItems"
                >{{ item.title }}</div>
            </div>
        </div>
		<div class="secLevel__wrapper">
			<div v-if="showSecLevelConfig" class="secLevel">
				<secondLevelRectanglesContent :blockValues="blockImages" :fieldsConfig="getSecLevelFieldsConfig('basic')" :config = this.secLevelConfig></secondLevelRectanglesContent>
				<secondLevelRectanglesContent :blockValues="blockImages" :fieldsConfig="getSecLevelFieldsConfig('happy')" :config = this.secLevelConfig.greenScreen></secondLevelRectanglesContent>
				<secondLevelRectanglesContent :blockValues="blockImages" :fieldsConfig="getSecLevelFieldsConfig('soso')" :config = this.secLevelConfig.yellowScreen></secondLevelRectanglesContent>
				<secondLevelRectanglesContent :blockValues="blockImages" :fieldsConfig="getSecLevelFieldsConfig('bad')" :config = this.secLevelConfig.redScreen></secondLevelRectanglesContent>
			</div>
		</div>
		<div class="saveBtn__wrapper">
			<div class="saveBtn" @click="saveSecondLevelConfigClick">
              {{ translate('Save') }}
			</div>
		</div>
	</div>
</template>

<script>
    import customModalDialog from "./customModalDialog";
    import secondLevelRectanglesContent from "./secondLevelRectanglesContent";
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import errorMixin from "@/mixins/errorMixin";
    import config from "@/api/config";
    import 'verte/dist/verte.css';
    import sldDefault from "@/helpers/sldDefault";
    export default {
        mixins: [errorMixin],
        name: "SecondLevelDetailsConfig",
        components: {
            customModalDialog,
			      secondLevelRectanglesContent
        },
        data() {
            return {
                showSecLevelConfig: false,
                place_guid: null,
                organization_guid: null,
                question_guid: null,
				secLevelFieldsConfig: {
					showMainCheckbox: true,
					title: null,
					showBackground: true,
					showMaxCountSelectedItems: true,
					showCommentAlways: true,
					showOverrideBasicBlocks: true,
					showOverrideBasicSettings: true,
					blocksHaveIcons: true,
				},
                secLevelConfig: {
                    show: true,
                    title: '',
                    background: "#8080804C",
                    maxCountSelectedItems: 0,
                    showCommentAlways: false,
                    overrideBasicBlocks: true,
                    overrideBasicSettings: false,
                    blocks: [
                        {
                            icon: '',
                            text: '',
                            value: '',
                            hash: '',
                            overrideAutoCameraOpenFlow: false,
                            auto_open_camera: false,
                        },
                    ],
                    overrideSubtitle: false,
                    subtitle: '',
                    overrideAutoCameraOpenFlow: false,
                    auto_open_camera: false,
                    greenScreen: {
                        show: false,
                        title: '',
                        background: '#4383484C',
                        maxCountSelectedItems: 0,
                        overrideBasicBlocks: false,
                        overrideBasicSettings: false,
                        showCommentAlways: false,
                        blocks: [],
                        overrideSubtitle: false,
                        subtitle: '',
                        showSocialTitle: false,
                        social_title: '',
                        overrideAutoCameraOpenFlow: false,
                        auto_open_camera: false,
                    },
                    yellowScreen: {
                        show: false,
                        title: '',
                        background: '#FF9D004F',
                        showCommentAlways: false,
                        maxCountSelectedItems: 0,
                        overrideBasicBlocks: false,
                        overrideBasicSettings: false,
                        blocks: [],
                        overrideSubtitle: false,
                        subtitle: '',
                        showSocialTitle: false,
                        social_title: '',
                        overrideAutoCameraOpenFlow: false,
                        auto_open_camera: false,
                    },
                    redScreen: {
                        title: '',
                        background: '#B517004C',
                        showCommentAlways: false,
                        maxCountSelectedItems: 0,
                        show: false,
                        overrideBasicBlocks: false,
                        overrideBasicSettings: false,
                        blocks: [],
                        overrideSubtitle: false,
                        subtitle: '',
                        showSocialTitle: false,
                        social_title: '',
                        overrideAutoCameraOpenFlow: false,
                        auto_open_camera: false,
                    },
                },
                blockImages: [],
                customModalSettings: {},
                takeSecLevelFromPlace: false,
                defaultItems: sldDefault.sldDefaultOptions,

            }
        },
        watch: {
            takeSecLevelFromPlace(newValue) {
                if(newValue) this.showSecLevelConfig = false
            },
            showSecLevelConfig(newValue) {
                if(newValue) {
                  this.takeSecLevelFromPlace = false
                  this.secLevelConfig.show = true
                  this.secLevelConfig.overrideBasicBlocks = true
                  this.secLevelConfig.overrideBasicSettings = true
                  this.secLevelConfig.showCommentAlways = true
                    this.secLevelConfig.yellowScreen.show = true
                    this.secLevelConfig.yellowScreen.overrideBasicSettings = true
                    this.secLevelConfig.yellowScreen.showCommentAlways = true
                    this.secLevelConfig.yellowScreen.title = 'sld.title_soso'
                    this.secLevelConfig.redScreen.show = true
                    this.secLevelConfig.redScreen.overrideBasicSettings = true
                    this.secLevelConfig.redScreen.showCommentAlways = true
                    this.secLevelConfig.redScreen.title = 'sld.title_sad'
                }
            }
        },
        props: ['admin', 'showConfigPopup'],
        mounted() {
            this.getParams()
            this.fetchSecLevelConfigFromPlaceAction()
            this.getBlockImages()
          // window.location.reload()
        },

        methods: {
            ...mapActions({
                fetchSecondLevelConfig: 'place/fetchSecondLevelConfig',
                saveSecondLevelConfig: 'place/saveSecondLevelConfig',
                saveSecondLevelConfigForQuestion: 'question/saveSecondLevelConfigForQuestion',
                fetchSecondLevelConfigForQuestion: 'question/fetchSecondLevelConfigForQuestion',
                getIconsForBlockImagesSld: 'question/getIconsForBlockImagesSld',

            }),
            ...mapMutations({
                setProgressBarTag: 'setProgressBarTag'
            }),

            getSecLevelConfigClick() {
                this.fetchSecLevelConfigFromPlaceAction()
            },

            async fetchSecLevelConfigFromPlaceAction() {
                try {
                    this.setProgressBarTag({
                        show: true,
                        tag: 'fetch_secLevelConfig'
                    })
                    let response
                    if(this.question_guid) {
                      response = await this.fetchSecondLevelConfigForQuestion({
                        org_guid: this.organization_guid,
                        place_guid: this.place_guid,
                        question_guid: this.question_guid
                      });
                    } else {
                      response = await this.fetchSecondLevelConfig({
                        org_guid: this.organization_guid,
                        place_guid: this.place_guid
                      });
                    }
                    if (response.success) {
                        response.second_level_config !== null && response.second_level_config.length == 0 ? this.takeSecLevelFromPlace = true : this.showSecLevelConfig = true
                        this.showSecLevelConfig = response.second_level_config !== null
                        if(this.showConfigPopup && response.second_level_config == null) {
                            this.customModalSettings = {
                              message: this.translate('configMissingMsg'),
                              onOkHandler: this.showDefaultConfig,
                              onCancelHandler: this.backToPreviousPageAction,
                              showCancelButton: true,
                              okButtonText: this.translate('yes'),
                              cancelButtonText: this.translate('no'),
                            }
                        }
                        this.parseDataFromJsonConfig(response.second_level_config)
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                } finally {
                    this.setProgressBarTag({
                        show: false,
                        tag: 'fetch_secLevelConfig'
                    })
                }
            },
            parseDataFromJsonConfig(config) {
                this.checkSecLevelConfigBlocks(this.secLevelConfig, config)
                this.checkSecLevelConfigBlocks(this.secLevelConfig.greenScreen, config.happy, '#4383484C')
                this.checkSecLevelConfigBlocks(this.secLevelConfig.redScreen, config.sad, '#FF9D004F')
                this.checkSecLevelConfigBlocks(this.secLevelConfig.yellowScreen, config.so_so, '#B517004C')
            },
            checkSecLevelConfigBlocks(block, response, defBackgroundColor) {
                if (response == null || response.length == 0) {
                    block.show = false
                    block.overrideBasicSettings = false
                    block.overrideBasicBlocks = false

                    block.showSocialTitle = false
                    block.social_title = ''
                } else {
                    if(response.default_view == true) {
                        block.showSocialTitle = response.social_title != null
                        block.social_title = response.social_title == null ? '' : response.social_title
                    } else {
                        block.show = true
                        if (response.title != null || response.background != null || response.selected_count_max != null
                            || response.show_comment_always != null || response.subtitle != null) {
                            block.overrideBasicSettings = true
                            block.title = response.title == null ? "" : response.title
                            block.background = response.background == null ? defBackgroundColor : response.background
                            block.maxCountSelectedItems = response.selected_count_max == null ? 0 : response.selected_count_max
                            block.showCommentAlways = response.show_comment_always == null ? false : response.show_comment_always
                            if (response.subtitle == null) {
                                block.subtitle = null
                                block.overrideSubtitle = false
                            } else {
                                block.subtitle = response.subtitle
                                block.overrideSubtitle = true
                            }
                            if (response.auto_open_camera == null) {
                                block.auto_open_camera = false
                                block.overrideAutoCameraOpenFlow = false
                            } else {
                                block.auto_open_camera = response.auto_open_camera
                                block.overrideAutoCameraOpenFlow = true
                            }
                        } else {
                            block.overrideBasicSettings = false
                        }
                        if (response.blocks != null) {
                            block.overrideBasicBlocks = true
                            let blocks = []
                            response.blocks.forEach((element) => {
                                let block = {
                                    icon: element.icon,
                                    text: element.text,
                                    value: element.text,
                                    overrideAutoCameraOpenFlow: element.auto_open_camera != null,
                                    auto_open_camera: element.auto_open_camera != null ? element.auto_open_camera : false,
                                }
                                blocks.push(block)
                            })
                            block.blocks = blocks
                        } else {
                            block.blocks = []
                            block.overrideBasicBlocks = false
                        }
                    }
                }
            },
            backToPreviousPageAction() {
              this.$router.go(-1);
            },
            async getBlockImages () {
                try {
                  let response = await this.getIconsForBlockImagesSld()
                  if (response.success) {
                    let images = response.images.map(element => {
                      return {
                        icon: element.tag,
                        text: element.default_text,
                        value: element.default_text,
                        uid: element.uid,
                        hash: '',
                      }
                    })
                    this.blockImages = images

                  }
                } catch (error) {
                  this.showErrorModal(error.data.error.message)
                }
            },

            saveSecondLevelConfigClick() {
                this.saveSecondLevelConfigAction()
            },
            async saveSecondLevelConfigAction() {
                let data
                if(this.showSecLevelConfig) {
                  this.secLevelConfig.show = true
                  this.secLevelConfig.overrideBasicSettings = true
                  this.secLevelConfig.overrideBasicBlocks = true

                  data = this.saveBlockAction(this.secLevelConfig)
                  data.happy = this.saveBlockAction(this.secLevelConfig.greenScreen)
                  data.so_so = this.saveBlockAction(this.secLevelConfig.yellowScreen)
                  data.sad = this.saveBlockAction(this.secLevelConfig.redScreen)
                } else if(this.takeSecLevelFromPlace) {
                  data = []
                } else {
                  data = null
                }
                try {
                    this.setProgressBarTag({
                        show: true,
                        tag: 'save_secLevelConfig'
                    })
                    let response
                    if(this.question_guid) {
                        response = await this.saveSecondLevelConfigForQuestion({
                          org_guid: this.organization_guid,
                          place_guid: this.place_guid,
                          question_guid: this.question_guid,
							second_level_config: data
                        });
                    } else {
                        response = await this.saveSecondLevelConfig({
                          org_guid: this.organization_guid,
                          place_guid: this.place_guid,
							second_level_config: data
                        });
                    }
                    if (response.success) {
                        this.showErrorModal('Saved')
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                } finally {
                    this.setProgressBarTag({
                        show: false,
                        tag: 'save_secLevelConfig'
                    })
                }
            },
            saveBlockAction(config) {

                if(!config.show) {
                    let data = {
                        default_view: true,
                        social_title: config.showSocialTitle ? config.social_title : null,
                    }
                    return data
                }

                let data = {
                  title: null,
                  blocks: null,
                  background: null,
                  selected_count_max: null,
                  show_comment_always: null,
                }
                if(config.overrideBasicSettings) {
                  data.title = config.title
                  data.background = config.background
                  data.show_comment_always = config.showCommentAlways
                  data.selected_count_max = parseInt(config.maxCountSelectedItems)
                  if(config.overrideSubtitle) {
                     data.subtitle = config.subtitle
                  }
                  if(config.overrideAutoCameraOpenFlow) {
                     data.auto_open_camera = config.auto_open_camera
                  }
                }
				if(config.overrideBasicBlocks) {
                    let blocks = []
                    config.blocks.forEach((element) => {
                        let block = {
                            icon: element.icon,
                            text: element.text,
                            value: element.text,
                        }
                        if(element.overrideAutoCameraOpenFlow) {
                            block.auto_open_camera = element.auto_open_camera
                        }
                        blocks.push(block)
                    })
					data.blocks = blocks
				}
                return data
            },
            getParams() {
              this.place_guid = this.$route.params.uid
              this.organization_guid = this.$route.params.orgUid
              this.question_guid = this.$route.params.questionUid
            },
            showDefaultConfig() {
              this.showSecLevelConfig = true
              this.secLevelConfig.show = true
              this.secLevelConfig.overrideBasicSettings = true
              this.secLevelConfig.overrideBasicBlocks = true
            },
			getSecLevelFieldsConfig(type) {
				let config = JSON.parse(JSON.stringify(this.secLevelFieldsConfig))
				switch (type) {
					case 'basic':
						config.showMainCheckbox = false
						config.showOverrideBasicBlocks = false
						config.showOverrideBasicSettings = false
						config.title = this.translate('sldBasicConfig')
						break;
					case 'happy':
						config.title = this.translate('sldGreenScreen')
						break;
					case 'soso':
						config.title = this.translate('sldYellowScreen')
						break;
					case 'bad':
						config.title = this.translate('sldRedScreen')
						break;
				}
				return config
			},
            onDefConfigItemClick(config) {
                if(!this.showSecLevelConfig) this.showSecLevelConfig = true
                this.parseDataFromJsonConfig(JSON.parse(config))
            },
        }
    }
</script>


<style scoped>
    .verte {
      margin-left: 10px;
    }
    .placeId_input__wrapper {
        display: flex;
        max-width: 500px;
        align-items: center;
        justify-content: space-between;
    }
    .placeId_input__wrapper .md-field {
        max-width: 500px !important;
    }
    .wrapper.dashboard {
        margin-top: 25px;
    }
    .wrapper.admin_page {
        max-height: calc(100vh - 62px);
        overflow: scroll;
    }
    .wrapper::-webkit-scrollbar {
      display: none;
    }
    .get_place_config {
        color: white;
        background-color: #3F405C;
        padding: 15px;
        border-radius: 6px;
        cursor: pointer;
    }
    .secLevel {
        margin-left: 1em;
    }
    .item__wrapper {
        max-width: 560px;
        width: 100%;
        background: #F3F3F3;
        border: 1px solid #000000;
        box-sizing: border-box;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 4px;
        padding: 7px 33px 21px 10px;
        margin-bottom: 20px;
    }
    .screen__inputs {
        display: flex;
    }
    .screen__input:last-child {
        margin-left: 22px;
    }
    .screen__background {
        display: flex !important;
        justify-content: end;
        flex-direction: row;
        align-items: center;
        width: 100%;
        min-height: 48px;
        margin: 4px 0 24px;
        padding-top: 16px;
        position: relative;
    }
    .countSelected__inputs {
        display: flex;
        align-items: center;
    }
    .countSelected__input {
        width: 100%;
        max-width: 291px;
    }
    .block__wrapper {
        display: flex;
        align-items: center;
        margin-top: 15px;
    }
    .block-content {
        margin-left: 10px;
        width: 100%;
        background: #FFFFFF;
        box-sizing: border-box;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 9px;
        position: relative;
    }
    .block-image img {
        width: auto;
    }
    .block-input:first-child {
        margin-right: 20px !important;
    }
    .draggable-items {
        margin-top: 15px;
    }
    .md-menu-content.md-select-menu .md-list {
        display: flex !important;
        flex-direction: row !important;
    }
    .md-list-item-text div {
        display: flex !important;
        flex-direction: column;
        align-items: center;
    }
    .md-list-item-text img {
        height: 50px;
        width: 50px;
    }
    .md-menu-content {
        display: flex !important;
        flex-direction: row !important;
    }
    .block-icons {
        display: flex !important;
        flex-direction: column;

    }
    .trash-icon {
        cursor: pointer;
        position: absolute;
        top: 3px;
        right: 5px;
    }
    .trash-icon img {
        width: 13px;
        height: 13px;
    }
    .block-icons img {
        width: 35px;
        height: 35px;
    }
    .add_block_btn {
        cursor: pointer;
        display: flex;
        justify-content: center;
        margin-top: 15px;
        align-items: center;
    }
    .saveBtn__wrapper {
        margin-bottom: 250px;
        display: flex;
        justify-content: start;
        margin-left: 16px;
    }
    .saveBtn {
        cursor: pointer;
        background-color: #3F405C;
        color: white;
        padding: 15px;
        border-radius: 6px;
    }
    .default_configs_wrapper {
        display: flex;
        flex-direction: row;
        margin-top: 14px;
        flex-wrap: wrap;
        gap: 8px;
    }
    .def_conf_btn {
        cursor: pointer;
        background-color: #3F405C;
        color: white;
        padding-top: 8px;
        padding-bottom: 8px;
        padding-left: 12px;
        padding-right: 12px;
        border-radius: 6px;
        font-size: 15px;
    }
    .def_conf_btn:hover {
        background-color: #191a53;
        box-shadow: 0 3px 4px 0 rgb(0 0 0 / 30%);
    }
    .color_picker {
      cursor: pointer;
      margin-left: 10px;
      width: 50px;
      height: 15px;
    }
	.secLevel__wrapper {
		display: flex;
		justify-content: space-between;
	}
	.serviceLog__wrapper {
		max-width: 450px;
		width: 100%;
	}
	.saveBtn__serviceLog {
		cursor: pointer;
		background-color: #3F405C;
		color: white;
		padding: 15px;
		border-radius: 6px;
		max-width: 150px;
		text-align: center;
	}

</style>
